import {
    createSubPlayTemplateView,
    preloadSubPlayTemplateView,
    setSubPlayTemplateInfo
} from "../../api/nativeComponent/compSubPlayTemplateView";
import {appendSubView} from "../../api/nativeComponent/compVisibleCommon";
import {closeAd} from "../../api/nativeComponent/compCommon";
import SubTpl from "./SubTpl";

export default class VideoTemplateLegacy extends SubTpl {
    constructor(props) {
        super(props);

        let MTG_SDKContext = props.MTG_SDKContext
        if (typeof MTG_SDKContext === 'object' && MTG_SDKContext !== null) {
            this.unitId = MTG_SDKContext.unitId
            this.unitSetting = MTG_SDKContext.unitSetting
            this.sdkSetting = MTG_SDKContext.sdkSetting
        }
    }

    /**
     * 创建一个 ViewType 为 4 的原生播放模板视图
     * @param campaign
     * @returns {Promise<any>}
     */
    create({campaign}) {
        let unitId = this.unitId
        let unitSetting = this.unitSetting
        let sdkSetting = this.sdkSetting
        return createSubPlayTemplateView({campaign, unitId, unitSetting, sdkSetting})
    }

    preload({id}) {
        let unitId = this.unitId
        return preloadSubPlayTemplateView({unitId, id})
    }

    append({parentCmptId, childCmptId, rect}) {
        let unitId = this.unitId
        return appendSubView({unitId, parentCmptId, childCmptId, rect})
    }

    // show(instanceId) {
    //     // AOP showsuccess 开发者回调
    //     return showVideoTemplateLegacy(instanceId)
    // }
    //
    // hide(instanceId) {
    //     return hideVideoTemplateLegacy(instanceId)
    // }

    close({id}) {
        let unitId = this.unitId
        return closeAd({unitId, id})
        // return closeSubPlayTemplateView({unitId, id})
    }

    setSubPlayTemplateInfo({id, data}) {
        let unitId = this.unitId
        return setSubPlayTemplateInfo({unitId, id, data})
    }
}